/* import __COLOCATED_TEMPLATE__ from './individual-invalid-address.hbs'; */
import Component from '@glimmer/component';
import { feature } from '@square/ember-features/macros';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';

export default class IndividualInvalidAddressComponent extends Component {
  @service declare router: RouterService;

  @feature('banking/stop_prefilling_savings_onboarding')
  declare stopPrefilling: boolean;

  @action
  navigateToConfirm() {
    const route = this.stopPrefilling
      ? 'signup.enter-business-info'
      : 'signup.confirm-identity.index';
    this.router.transitionTo(route);
  }

  @action
  navigateToEdit() {
    const route = this.stopPrefilling
      ? 'signup.enter-identity-info'
      : 'signup.confirm-identity.edit';
    this.router.transitionTo(route);
  }
}
